import * as CoreFns from '../../utilities/CoreFns';
import * as ActionCasesFns from '../../utilities/ActionCasesFns';
import * as NamingFns from '../../utilities/NamingFns';
import * as StandardFns from '../../utilities/StandardFns';
import * as TypeEvaluation from '../../TypeEvaluation';
import * as TypeChecks from '../../TypeChecks';
import * as DesignerFunctions from '../../utilities/DesignerFunctions';
import * as SearchForAnEntityType from '../../utilities/SearchForAnEntityType';
import * as Combos from './Combos';

export function getOptionTypesFromTypeRequired(typeRequired, currentList, overallPath, chainId, smartContracts, relevantSpace, pathToHere, varsIn, actionCases, rFormSets, isFeOrPuAndthisFe){

  var optionTypes = [];

  if (typeRequired.t !== 'ScEvent'){
    optionTypes.push({t:'House Functions', i:'formula'});
  }

  if (typeRequired.t === 'Text String' || typeRequired.t === 'any'){
    optionTypes.push({t:'Text', i:'freeText'});
  }

  if (typeRequired.t === 'Integer' || typeRequired.t === 'any'){
    optionTypes.push({t:'Integer', i:'freeInteger'});
  }

  if ((typeRequired.t === 'UInteger' && typeRequired.sp !== 'dateTime') || typeRequired.t === 'any'){
    optionTypes.push({t:'+ Integer / 0', i:'freeUInteger'});
  }

  if ((typeRequired.t === 'UInteger' && typeRequired.sp === 'dateTime') || typeRequired.t === 'any'){
    optionTypes.push({t:'Date', i:'freeDateTime'});
  }

  if (typeRequired.t === 'Decimal' || typeRequired.t === 'any'){
    optionTypes.push({t:'Decimal', i:'freeDecimal'});
  }

  if (typeRequired.t === 'Address' || typeRequired.t === 'any'){
    optionTypes.push({t:'Address', i:'freeAddress'});
    var sc = currentList.sc;
    var scKeys1 = Object.keys(sc);
    if (scKeys1.length > 0){
      optionTypes.push({t:'Contract Address', i:'contractAddress'});
    }
  }

  if (typeRequired.t === 'Transaction' || typeRequired.t === 'any'){
    optionTypes.push({t:'Transaction', i:'freeTransaction'});
  }

  if (typeRequired.t === 'Screen'){
    optionTypes.push({t:'Page', i:'scr'});
  }

  if (typeRequired.t === 'Music'){
    optionTypes.push({t:'Music', i:'mus'});
  }

  if (pathToHere[0] === 'ov'){
  }else{
    var inputPiecesFromEverywhere = [];
    var inputsAllAround = SearchForAnEntityType.searchEntity(currentList, 'INPUT');
    inputsAllAround.forEach((anInput, index)=>{
      var overallPathLast = overallPath[overallPath.length - 1];
      if (overallPathLast.indexOf('value') === 0){
        if (overallPath.join(' ').indexOf(anInput.path.join(' ')) === 0){
          return;
        }
      }
      var iT = TypeEvaluation.getInputTypeFromInput(anInput.item);
      var match = TypeChecks.checkMatch(iT, typeRequired, true);
      if (match){
        inputPiecesFromEverywhere.push(anInput);
      }
    })


    var radioPiecesFromEverywhere = [];
    var radiosAllAround = SearchForAnEntityType.searchEntity(currentList, 'RADIO');
    radiosAllAround.forEach((aRadio, index)=>{
      var iT = {t:'Choice', v:aRadio.path.join('_')}
      var match = TypeChecks.checkMatch(iT, typeRequired, true);
      if (match){
        radioPiecesFromEverywhere.push(aRadio);
      }    
    })


    if (inputPiecesFromEverywhere.length > 0){
      optionTypes.push({t:'Input Values', i:'inP', v:inputPiecesFromEverywhere});
    }

    if (radioPiecesFromEverywhere.length > 0){
      optionTypes.push({t:'Choice Values', i:'choices', v:radioPiecesFromEverywhere});
    }

  }

  var existingScFunctions = [];
  var scEvents = [];

  function iterateThroughOutputTypeForEs(outputT, functionNos, aScKey, name, nosInputs, contractName, nosOutputs, aPath, txtPath){
    if (outputT.type.indexOf('bytes') === 0){
    // }else if (outputT.type === 'tuple'){
    //   var components = outputT.components;
    //   components.forEach((aComponent, index)=>{
    //     iterateThroughOutputTypeForEs(aComponent, functionNos, index3, aScKey, name, contractName, nosOutputs, aPath.concat([index]), txtPath.concat([aComponent.name]))
    //   })
    }else{

      var txt = contractName + '.' + name;
      var whichFunction:'';
      if (nosOutputs > 1){
        txt += '.' + outputT.name;
        whichFunction = outputT.name;
      }

 // 
      walkDownType(existingScFunctions, 'eS', TypeEvaluation.convertSCTypeToInternalType(outputT), {s:aScKey, i:name + ' ' + nosInputs, n:whichFunction, a:aPath}, txt, []);

    }
  }    

    if (typeRequired.t === 'ScEvent'){
      var tgt;
      if (pathToHere.length === 0){
        var locOfOnTrigger = -1; 
        for (var i5 = 0; i5 < overallPath.length; i5++){
          if (overallPath[i5] === 'On_Trigger'){
            locOfOnTrigger = i5;
          }
        }

        var filPieceUntilLastOnTrigger = overallPath.filter((aP, index5)=>{
          return +index5 < locOfOnTrigger;
        })

        var here = CoreFns.goDownPath(currentList, filPieceUntilLastOnTrigger, 0);
        tgt = here.v;
      }else if (pathToHere.length === 2){
        tgt = relevantSpace.x[0].s;
      }else{
        var ePath = pathToHere[pathToHere.length - 3];
        var rr = CoreFns.goDownPath(relevantSpace, ['y', ePath.k]);
        tgt = rr.x[0].s
      }
      var Abi = CoreFns.getContractInfoAbi(currentList, tgt);
      if (Abi){
        Abi.forEach((aAbi, index2)=>{
          if (aAbi.type === 'event'){

            walkDownType(scEvents, 'eV', {t:'ScEvent'}, {s:tgt, i:+index2}, aAbi.name + ' event', []);

            // scEvents.push({s:tgt, i:+index2, t:aAbi.name + ' event'});
          }
        })
      }

    }

    var scKeys = [];
    if (smartContracts){
      scKeys = Object.keys(smartContracts);
    }

    scKeys.forEach((aScKey, index)=>{
      var Abi = CoreFns.getContractInfoAbi(currentList, aScKey);
      var contractInfo = CoreFns.getContractInfo(currentList, aScKey);
      if (Abi){
        Abi.forEach((aAbi, index2)=>{
          if (aAbi.type === 'function' && (aAbi.stateMutability === 'view' || aAbi.stateMutability === 'pure')){
            var nosOutputs = aAbi.outputs.length;
            aAbi.outputs.forEach((outputT, index3)=>{
              iterateThroughOutputTypeForEs(outputT, +index2, aScKey, aAbi.name, aAbi.inputs.length, contractInfo.contractName, nosOutputs, [], []);
            })
          }
        })
      }
    })

    if (existingScFunctions.length > 0){
      optionTypes.push({t:'Contract Functions', i:'eS', v:existingScFunctions});
    }

    if (scEvents.length > 0){
      optionTypes.push({t:'Contract Events', i:'eV', v:scEvents});
    }    
  

//oP only has n.

  function walkDownType(suggestions, optionType, ownVarType, key, varName, path){
    var match = TypeChecks.checkMatch(ownVarType, typeRequired, true);
    if (match){
      var t = NamingFns.expandPath(varName, path, currentList, false, false); //the false false doesn't matter cos its only l or oP that we use.
      suggestions.push({optionType, t, v:key, p:path});
    }

    if (ownVarType.t === 'ListType'){
      walkDownType(suggestions, optionType, ownVarType.c, key, varName, path.concat([{t:'l'}]))
    }else if (ownVarType.t === 'MaybeSpecified'){
      walkDownType(suggestions, optionType, ownVarType.c[0], key, varName, path.concat([{t:'l'}]))
    }else if (ownVarType.t === 'Object'){
      for (var i = 0; i < ownVarType.c.length; i++){
        walkDownType(suggestions, optionType, ownVarType.c[i].t, key, varName, path.concat([{t:'oP', n:ownVarType.c[i].n}]))
      }
    }
  }

  var vars = [];
  varsIn.forEach((aVar, index)=>{
      walkDownType(vars, 'm', aVar.t, aVar.m, 'Variable ' + aVar.m, []);
  })
  if (vars.length > 0){
    optionTypes.push({t:'Map / Filter / Reduce / Comparison variables', i:'m', v:vars})
  }

  var ownVariablePieces = [];
  var ov = currentList.ov;
  if (ov){
     var ovKeys = CoreFns.sortedKeyList(ov);
     for (var i6 = 0; i6 < ovKeys.length; i6++){
      var anOVKey = ovKeys[i6];
      if (overallPath[0] === 'ov'){
        if (anOVKey === overallPath[1]){
          break;
        }
      }
      var thisOwnVar = ov[anOVKey];
      var ovType = CoreFns.convertSelectionToType(thisOwnVar.t, currentList);
      walkDownType(ownVariablePieces, 'oVar', ovType, anOVKey, thisOwnVar.n, []);
     }
  }

  if (ownVariablePieces.length > 0){
    optionTypes.push({t:'Own Variables', i:'oVar', v:ownVariablePieces});
  }

  var combos = Combos.getCombos(typeRequired, currentList);
  if (combos.length > 0){
    optionTypes.push({t:'Combos', i:'combos', v:combos});
  }

  var actionPieces2 = [];
  actionCases.forEach((aCase, index)=>{
    var txt = ActionCasesFns.getActionCaseTitle(aCase);
      walkDownType(actionPieces2, 'aC', aCase.tS, {k:aCase.k, s:aCase.s}, txt + ' ' + aCase.k, []);
  })

  if (actionPieces2.length > 0){
    optionTypes.push({t:'Actions', i:'aC', v:actionPieces2});
  }


  if (typeRequired.t === 'Coin'){
    optionTypes.push({t:'Coins', i:'coin'});
  }

  if (typeRequired.t === 'Currency'){
    optionTypes.push({t:'Currency', i:'curr'});
  }

  var gVs = [];
  rFormSets.forEach((aVar, index)=>{
    var titleX = 'Governing Value of ' +  DesignerFunctions.getItemTitle(currentList, aVar.plusOne, 'item');
    walkDownType(gVs, 'gV', aVar.type, aVar.plusOne, titleX, []);
  })

  if (gVs.length > 0){
    optionTypes.push({t:'Parental Functions', i:'gV', v:gVs});
  }

  if (typeRequired.t === 'Panel'){
    var upToScreen = [isFeOrPuAndthisFe.t, isFeOrPuAndthisFe.v, '_s'];
    var panels = CoreFns.goDownPath(currentList, upToScreen);
    var panelKeys = Object.keys(panels);
    var panelVs = panelKeys.map((aPanel, index)=>{
      var thisPanelPath = upToScreen.concat([aPanel]);
      var thisPanel = panels[aPanel];
      var name = 'Unnamed Panel';
      if (thisPanel._na){
        name = 'Panel ' + thisPanel._na;
      }
      return {n:name, p:thisPanelPath}
    })
    optionTypes.push({t:'Panels', i:'panels', v:panelVs});
  }else if (typeRequired.t === 'Alert'){
    var alertVs = [];
    var screenSets = ['fe', 'pu'];
    screenSets.forEach((aSSet, index4)=>{
      var frontEnds = currentList[aSSet];
      var frontEndKeys = Object.keys(frontEnds);
      frontEndKeys.forEach((aFEKey, index)=>{
        var screens = frontEnds[aFEKey]._s;
        var screenKeys = Object.keys(screens);
        screenKeys.forEach((aScreenKey, index2)=>{
          var alerts = screens[aScreenKey].al;
          var alertKeys = Object.keys(alerts);
          alertKeys.forEach((anAlertKey, index3)=>{
            var path = [aSSet, aFEKey, '_s', aScreenKey, 'al', anAlertKey];
            var alertName = CoreFns.goDownPath(currentList, path.concat('_na'));
            alertVs.push({n:alertName, p:path});

          })
        })
      })

    })

      optionTypes.push({t:'Banners', i:'al', v:alertVs});
  }else if (typeRequired.t === 'PopUp'){
    optionTypes.push({t:'Pop Ups', i:'pu'});
  }

  if (typeRequired.t === 'Text String' || typeRequired.t === 'Integer' || typeRequired.t === 'UInteger' || typeRequired.t === 'Decimal' || typeRequired.t === 'Adderss'){
    optionTypes.push({t:'Placeholder',i:'pl', type:typeRequired.t});
  }

  return optionTypes;
}

export function findAllVariablesWithTheirAssociatedTypesMarch(relevantSpace, k, overallPath, currentList, actionCases){


  var toAdd = [];
  for (var i2 = 0; i2 < k.length; i2++){
    var relevantPointer = k[i2];
    var xS = [];
    if (relevantPointer.p === ''){
      xS = relevantSpace.x;
    }else{
      var node = CoreFns.goDownPath(relevantSpace, ["y", relevantPointer.p], 0);
      xS = node.x;
    }
    var i = relevantPointer.i;
    var firstNode = xS[0];
    if (firstNode.t === 'f'){ 
      if (i < xS.length){
        var nextTgt = xS[i].v;
        if (relevantSpace.y[nextTgt]){
          var v = firstNode.v;
          if (((v === 58 || v === 59 || v === 24) && i === 2) || (v === 71 && i === 3)){
            var listVarType = getTypeRequiredK(relevantSpace, ['y',xS[1].v,'x'], overallPath, currentList, toAdd, actionCases, true);
            if (listVarType !== 'error'){
              if (listVarType){
                if (listVarType.c){
                  toAdd.push({t:listVarType.c, m:firstNode.m0});
                  if (v === 24){
                    toAdd.push({t:listVarType.c, m:firstNode.m1});
                  }
                }
              }
            }

            
            if (v === 71 && i === 3){
              var startVarType = getTypeRequiredK(relevantSpace, ['y',xS[2].v,'x'], overallPath, currentList, toAdd, actionCases, true);
              if (startVarType !== 'error'){
                toAdd.push({t:startVarType, m:firstNode.m1});
              }
            }

          }

        }

      }
      // for (var i = 1; i < xS.length; i++){ //lets see if the above method stabilize, then can delete this. 
      // }//may not need to do it this way. instead just add only if the subsequent path is really on path. 
    }
  }

  return toAdd;
}

export function findMatchAmongInTypes(inType, whichNos, gOfInType, relevantSpace, overallPath, currentList, vars, actionCases){
  if (inType.t === 'match'){
    if (inType.v === whichNos){
      return getTypeRequiredK(relevantSpace, ['y', gOfInType, 'x'], overallPath, currentList, vars, actionCases, true);
    }
  }else if (inType.t === 'ListType' ){
    var c = findMatchAmongInTypes(inType.c, whichNos, gOfInType, relevantSpace, overallPath, currentList, vars, actionCases);
    if (c){
      if (c === 'error'){
        return false;
      }else{
        if (c.c){
          return c.c[0];
        }else{
          return false;
        }
      }
    }
  }else if (inType.t === 'MaybeSpecified'){
    var c1 = findMatchAmongInTypes(inType.c[0], whichNos, gOfInType, relevantSpace, overallPath, currentList, vars, actionCases);
    if (c1){
      if (c1 === 'error'){
        return false;
      }else{
        if (c1.c){
          return c1.c[0];
        }else{
          return false;
        }
      }
    }
  }

  return false;
}


export function getTypeRequiredK(relevantSpace, keyPath, overallPath, currentList, vars, actionCases, checkChildren){

    var xS = CoreFns.goDownPath(relevantSpace, keyPath, 0);
    if (xS.length === 0){
      return 'error';
    }
    var firstNode = xS[0];
    var ft = firstNode.t;
    if (ft === 'u'){
      return 'error';
    }else if (ft === 'inP'){
      return TypeEvaluation.getInputTypeFromKey(currentList, firstNode.v);
    }else if (ft === 'gV'){
      return TypeEvaluation.typeOfAGoverningFormula(firstNode, currentList, vars);
    }else if (ft === 'eS'){
      return TypeEvaluation.getESType(firstNode, currentList);
    }else if (ft === 'var'){
      return formulaVariableType(relevantSpace, firstNode);
    }else if (ft === 'f'){ 
      var fn1 = getRelevantFn(firstNode.v);
      var inTypes = fn1.in;
      function resolveOutType(outType){


          if (outType.t === 'any' || outType.t === 'nos'){
            if (checkChildren){
              for (var i = 0; i < inTypes.length; i++){
                if (i+1 < xS.length){
                  var toAdd = [];
                  if ((firstNode.v === 24 && i === 1) || (firstNode.v === 58 && i === 1) || (firstNode.v === 59 && i === 1) || (firstNode.v === 71 && i === 2)){
                    var listVarType = getTypeRequiredK(relevantSpace, ['y',xS[1].v,'x'], overallPath, currentList, vars, actionCases, true);
                    if (listVarType !== 'error'){
                      if (listVarType){
                        if (listVarType.c){
                          toAdd.push({t:listVarType.c, m:firstNode.m0});
                          if (firstNode.v === 24){
                            toAdd.push({t:listVarType.c, m:firstNode.m1});
                          }
                        }
                        // if (listVarType.c){
                        //   toAdd.push({t:listVarType.c[0], m:firstNode.m0});
                        // }
                      }
                    }

                  }
                  if (firstNode.v === 71 && i === 2){
                    var startVarType = getTypeRequiredK(relevantSpace, ['y',xS[2].v,'x'], overallPath, currentList, vars, actionCases, true);
                    if (startVarType !== 'error'){
                      toAdd.push({t:startVarType, m:firstNode.m1});
                    }
                  }
                  var inTypeChecked = findMatchAmongInTypes(inTypes[i], outType.v, xS[i+1].v, relevantSpace, overallPath, currentList, vars.concat(toAdd), actionCases);
                  if (inTypeChecked){
                    if (inTypeChecked === 'error'){
                      return outType;
                    }else{
                      return inTypeChecked;
                    }
                  }
                }else{
                  if (firstNode.v === 60){
                    return {t:'any'};
                  }
                  return 'error';
                }
              }
          }
        }else if (outType.t === 'ListType' ){
          var pp = resolveOutType(outType.c);
          return {t:outType.t,c:pp};
        }else if (outType.t === 'MaybeSpecified'){
          var pp5 = resolveOutType(outType.c[0]);
          return {t:outType.t,c:[pp5]};
        }
        return outType;

      }
      return resolveOutType(fn1.out);

    }else if (ft === 'm'){
      for (var i6 = 0; i6 < vars.length; i6++){
        if (vars[i6].m === firstNode.v){
          return TypeEvaluation.walkDownObjPathToGetType(vars[i6].t, firstNode.p);
        }
      }
    }else if (ft === 'aC'){
      return ActionCasesFns.getType(actionCases, firstNode);
    }else {
      return TypeEvaluation.simpEvalType(firstNode, currentList, overallPath);
    }
}


export function getTypeFromNode(node, typeRequired, currentList, overallPath, chainId, smartContracts, relevantSpace, pathToHere, varsIn, actionCases, rFormSets, isFeOrPuAndthisFe){
  if (node){
    if (node.x.length > 0){
      var xS = node.x[0];
      var xt = xS.t;
      if (xt === 's'){
        return 'freeText';
      }else if (xt === 'i'){
        return 'freeInteger';
      }else if (xt === 'ui'){
        return 'freeUInteger';
      }else if (xt === 'dt'){
        return 'freeDateTime';
      }else if (xt === 'dc'){
        return 'freeDecimal';
      }else if (xt === 'ad'){
        return 'freeAddress';
      }else if (xt === 'ca'){
        return 'contractAddress';
      }else if (xt === 'tx'){
        return 'freeTransaction';
      }else if (xt === 'pa' || xt === 'footer'){
        return 'panels';
      }else if (xt === 'oVar' || xt === 'al'  || xt === 'scr' || xt === 'mus' || xt === 'inP' || xt === 'pl' || xt === 'pu' || xt === 'curr' || xt === 'coin' || xt === 'aC' || xt === 'gV' || xt === 'eS' || xt === 'eV' || xt === 'm'){
        return xt;
      }else{
        return 'formula';
      }
    }else{
      if (typeRequired.t === 'Coin'){
        return 'coin';
      }else if (typeRequired.t === 'Currency'){
        return 'curr';
      }else if (typeRequired.t === 'Panel'){
        return 'panels';
      }else if (typeRequired.t === 'PopUp'){
        return 'pu';
      }else if (typeRequired.t === 'Alert'){
        return 'al';
      }else{
        var optionTypes = getOptionTypesFromTypeRequired(typeRequired, currentList, overallPath, chainId, smartContracts, relevantSpace, pathToHere, varsIn, actionCases, rFormSets, isFeOrPuAndthisFe);
        if (optionTypes.length > 0){
          return optionTypes[0].i;        
        }
      }

    }
  }
  return "formula";
}


export function formulaVariableType(relevantSpace, firstNode){
  if (relevantSpace.iS[firstNode.v]){
    var type = relevantSpace.iS[firstNode.v].t;
    return TypeEvaluation.walkDownObjPathToGetType(type, firstNode.p);
  }else{
    return {t:'deletedAlready'};
  }
}

export function getRelevantFn(v){
  return StandardFns.functionalPieces[v];
}
